<template>
  <div
    class="footer-bottom-bar mx-auto px-4 pb-6 sm:px-6 lg:px-8"
    :class="backgroundColorClass(bgVariant)"
  >
    <div
      class="mt-6 pt-6 md:flex md:items-center md:justify-between"
      :class="[
        isBackgroundDark(bgVariant) ? 'border-white/30' : 'border-black/30',
        blok.bottomBarBgVariant === blok.bgVariant ? 'border-t' : '',
      ]"
    >
      <div
        v-if="
          blok.followIconsPosition === 'bottomBar' || !blok.followIconsPosition
        "
        class="flex space-x-6 md:order-2"
      >
        <template v-for="channel in sortedChannels" :key="channel.name">
          <SocialMediaLink
            v-if="channel.url"
            :class="linkClass"
            :channel="channel"
            :use-brand-color="false"
          />
        </template>
      </div>
      <div
        class="rich-text prose text-sm md:order-1"
        :class="
          isBackgroundDark(bgVariant)
            ? 'rich-text-light prose-white prose-invert text-gray-300'
            : 'rich-text-dark text-gray-800'
        "
        v-html="copyright"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { renderRichText } from '@storyblok/vue'
import SocialMediaLink from '../components/SocialMediaLink.vue'
import { useColorPalette } from '../composables/colorPalette'

const props = defineProps({
  blok: {
    type: Object,
    default: () => {},
  },
  context: {
    type: Object,
    default: () => {},
  },
})

const { backgroundColorClass, isBackgroundDark } = useColorPalette()

const bgVariant = computed(() => {
  return props.blok.bottomBarBgVariant || props.blok.bgVariant
})
const copyright = computed(() => {
  return renderRichText(props.blok.copyright || '')
})
const linkClass = computed(() => {
  return isBackgroundDark(bgVariant.value)
    ? 'text-gray-300 hover:text-gray-100 focus:text-gray-100'
    : 'text-gray-700 hover:text-gray-800 focus:text-gray-800'
})
const sortedChannels = computed(() => {
  return [...channels.value].sort((a, b) => a.order - b.order)
})
const channels = computed(() => {
  return [
    {
      name: 'facebook',
      order: +props.blok.facebookPosition || 0,
      url: props.blok.facebookUrl,
      label: 'Facebook',
    },
    {
      name: 'twitter',
      order: +props.blok.twitterPosition || 0,
      url: props.blok.twitterUrl,
      label: 'Twitter',
    },
    {
      name: 'linkedin',
      order: +props.blok.linkedinPosition || 0,
      url: props.blok.linkedinUrl,
      label: 'LinkedIn',
    },
    {
      name: 'instagram',
      order: +props.blok.instagramPosition || 0,
      url: props.blok.instagramUrl,
      label: 'Instagram',
    },
    {
      name: 'youtube',
      order: +props.blok.youtubePosition || 0,
      url: props.blok.youtubeUrl,
      label: 'Youtube',
    },
    {
      name: 'glassdoor',
      order: +props.blok.glassdoorPosition || 0,
      url: props.blok.glassdoorUrl,
      label: 'Glassdoor',
    },
    {
      name: 'tiktok',
      order: +props.blok.tiktokPosition || 0,
      url: props.blok.tiktokUrl,
      label: 'Tiktok',
    },
  ]
})
</script>
